module.exports = __webpack_public_path__ + "static/media/seafood-noodle-basket-uncropped.13555590.png";